export default "__VITE_ASSET__442887f3__"